import React from "react";
import { FaCode, FaMobileAlt, FaCloud, FaCreditCard, FaShieldAlt, FaChartLine, FaUsers, FaHotel, FaHeadset } from "react-icons/fa";

const servicesData = [
  { icon: <FaCode className="text-blue-400 w-8 h-8" />, title: "Web Development", description: "Engaging, high-performance hotel websites built with the latest technologies to attract more guests." },
  { icon: <FaMobileAlt className="text-green-400 w-8 h-8" />, title: "Mobile Apps", description: "Seamless mobile apps for iOS & Android, keeping your hotel connected with guests 24/7." },
  { icon: <FaCloud className="text-purple-400 w-8 h-8" />, title: "Booking System", description: "Smart reservation systems with real-time availability and instant confirmations." },
  { icon: <FaCreditCard className="text-yellow-400 w-8 h-8" />, title: "Payment Gateway", description: "Secure, multi-currency payment solutions to make transactions quick and hassle-free." },
  { icon: <FaShieldAlt className="text-red-400 w-8 h-8" />, title: "Security", description: "Advanced security features to protect customer data and ensure safe online experiences." },
  { icon: <FaChartLine className="text-pink-400 w-8 h-8" />, title: "Sales Analytics", description: "Powerful reporting dashboards to track bookings, revenue, and customer trends." },
  { icon: <FaUsers className="text-indigo-400 w-8 h-8" />, title: "Customer Management", description: "Manage guest profiles, feedback, and loyalty programs to build long-lasting relationships." },
  { icon: <FaHotel className="text-teal-400 w-8 h-8" />, title: "Channel Manager", description: "Sync your rooms across multiple platforms like Booking.com, Agoda, and Expedia automatically." },
  { icon: <FaHeadset className="text-orange-400 w-8 h-8" />, title: "24/7 Support", description: "Round-the-clock technical and business support to ensure your hotel runs smoothly." },
];

const Solutions = () => {
  return (
    <section id="services" className="bg-gray-900 text-gray-300 py-16">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-400 mb-4">Our Services</h2>
        <p className="text-center text-gray-400 mb-12">
          Comprehensive technology solutions for modern businesses
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8">
          {servicesData.map((service, idx) => (
            <div key={idx} className="bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 text-center">
              <div className="mb-4 flex justify-center">{service.icon}</div>
              <h3 className="text-xl font-bold mb-2 text-white">{service.title}</h3>
              <p className="text-gray-400">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
